export const Heading = ({
                            level = 1,
                            children,
                            className = '',
                            ...props
                        }) => {
    const styles = {
        1: 'text-4xl font-bold leading-tight md:text-5xl',
        2: 'text-3xl font-bold tracking-tight lg:text-4xl',
        3: 'text-2xl font-bold tracking-tight lg:text-3xl',
        4: 'text-xl font-bold tracking-tight',
        5: 'text-lg font-semibold',
        6: 'text-base font-semibold',
    };

    const Tag = `h${level}`;

    return (
        <Tag className={`text-gray-900 ${styles[level] || styles[1]} ${className}`} {...props}>
            {children}
        </Tag>
    );
};

export const Text = ({
                         variant = 'body',
                         color = 'default',
                         children,
                         className = '',
                         ...props
                     }) => {
    const styles = {
        body: 'text-base leading-7',
        sm: 'text-sm leading-6',
        xs: 'text-xs leading-5',
        caption: 'text-[11px] leading-5',
        eyebrow: 'text-xs font-semibold uppercase tracking-[0.18em]',
    };

    const colors = {
        default: 'text-gray-900',
        muted: 'text-gray-500',
        subtle: 'text-gray-400',
        white: 'text-white',
        'white-muted': 'text-white/70',
        'white-subtle': 'text-white/45',
        emerald: 'text-emerald-700',
        'emerald-muted': 'text-emerald-700/80',
        'emerald-light': 'text-emerald-300',
    };

    return (
        <p className={`${styles[variant] || styles.body} ${colors[color] || colors.default} ${className}`} {...props}>
            {children}
        </p>
    );
};

const eyebrowColors = {
    default: 'text-gray-900',
    muted: 'text-gray-500',
    subtle: 'text-gray-400',
    white: 'text-white',
    'white-muted': 'text-white/70',
    'white-subtle': 'text-white/45',
    emerald: 'text-emerald-700',
    'emerald-muted': 'text-emerald-700/80',
    'emerald-light': 'text-emerald-300',
};

export const Eyebrow = ({
                            children,
                            className = '',
                            color = 'emerald-light',
                            ...props
                        }) => (
    <span
        className={`text-sm font-semibold uppercase tracking-[0.18em] ${eyebrowColors[color] || eyebrowColors['emerald-light']} ${className}`} {...props}>
        {children}
    </span>
);
